import { render, staticRenderFns } from "./KT-ResumeCertifications.vue?vue&type=template&id=662ff8ce&scoped=true&lang=pug&"
import script from "./KT-ResumeCertifications.vue?vue&type=script&lang=js&"
export * from "./KT-ResumeCertifications.vue?vue&type=script&lang=js&"
import style0 from "./KT-ResumeCertifications.vue?vue&type=style&index=0&id=662ff8ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662ff8ce",
  null
  
)

export default component.exports